import { useDispatch, useSelector } from "react-redux";
import { CustomizationProvider, CustomizationProviderProps } from "@twilio-paste/core/customization";
import { CSSProperties, FC, useEffect } from "react";

import { RootContainer } from "./RootContainer";
import { AppState, EngagementPhase } from "../store/definitions";
import { checkHoopStatus, sessionDataHandler } from "../sessionDataHandler";
import { initSession } from "../store/actions/initActions";
import { changeEngagementPhase } from "../store/actions/genericActions";

const AnyCustomizationProvider: FC<CustomizationProviderProps & { style: CSSProperties }> = CustomizationProvider;

export function WebchatWidget() {
    const theme = useSelector((state: AppState) => state.config.theme);
    const hoopConfig = useSelector((state: AppState) => state.config.hoop);
    const appConfig = useSelector((state: AppState) => state.config);
    const dispatch = useDispatch();

    useEffect(() => {
        let isMounted = true;

        const init = async () => {
            let isOpen = true;

            try {
                if (
                    hoopConfig?.checkHoopBeforeInit &&
                    hoopConfig?.hoopCheckEndpoint
                ) {

                    dispatch(changeEngagementPhase({ phase: EngagementPhase.Loading }));

                    isOpen = await checkHoopStatus(hoopConfig.hoopCheckEndpoint, hoopConfig.profileName || "");
                }
            } catch (err) {
                console.error("Error checking hoop status", err);
                // թույլ user to continue if hoop check fails
            }

            if (!isMounted) return;

            if (!isOpen) {
                dispatch(changeEngagementPhase({ phase: EngagementPhase.HoopCanvas }));
                return;
            }

            const data = sessionDataHandler.tryResumeExistingSession();

            if (data) {
                try {
                    dispatch(
                        initSession({
                            token: data.token,
                            conversationSid: data.conversationSid
                        })
                    );
                    return;
                } catch (e) {
                    console.error("Error initializing session", e);
                }
            }

            // fallback
            dispatch(changeEngagementPhase({ phase: EngagementPhase.PreEngagementForm }));
        };

        init();

        return () => {
            isMounted = false;
        };
    }, [dispatch, hoopConfig, appConfig]);

    return (
        <AnyCustomizationProvider
            baseTheme={theme?.isLight ? "default" : "dark"}
            theme={theme?.overrides}
            elements={{
                MESSAGE_INPUT: {
                    boxShadow: "none!important" as "none"
                },
                MESSAGE_INPUT_BOX: {
                    display: "inline-block",
                    boxShadow: "none"
                },
                ALERT: {
                    paddingTop: "space30",
                    paddingBottom: "space30"
                },
                BUTTON: {
                    "&[aria-disabled='true'][color='colorTextLink']": {
                        color: "colorTextLinkWeak"
                    }
                }
            }}
            style={{ minHeight: "100%", minWidth: "100%" }}
        >
            <RootContainer />
        </AnyCustomizationProvider>
    );
}
